import { render } from "./PosterBack.vue?vue&type=template&id=b373c818"
import script from "./PosterBack.vue?vue&type=script&lang=js"
export * from "./PosterBack.vue?vue&type=script&lang=js"

import "./PosterBack.vue?vue&type=style&index=0&id=b373c818&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__